import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, FormGroup, Form, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { observer } from 'mobx-react-lite';
import ReactCodeInput from 'react-code-input';

import '../FormComponents/styles.scss';
import '../Modal/styles.scss';
import { useStore } from '../../store';

const VerifyEmailModal = observer(({ toggle, isOpen }) => {
  const {
    rootStore: { profileStore },
  } = useStore();
  const { t } = useTranslation();
  const [code, setCode] = useState('');

  const triggerSave = value => {
    if (value.length === 6) {
      profileStore.contactStore.sendUpdateEmail(t).then(result => {
        if (result) {
          toggle();
        }
      });
    }
  };

  return (
    <Modal className="styled-modal" centered isOpen={isOpen} toggle={toggle}>
      <ModalHeader className="styled-header" toggle={toggle} />
      <ModalBody className="styled-modal-body">
        <Row>
          <Col>
            <h1>{t('verifyEmailModal.title')}</h1>
            <span>
              {t('verifyEmailModal.description', {
                userEmail: profileStore.contactStore.emailVerificationEmail,
              })}
            </span>
            <p>{t('verifyEmailModal.enterCode')}</p>
          </Col>
        </Row>
        <Form className="styled-form">
          <FormGroup>
            <ReactCodeInput
              type="number"
              fields={6}
              inputStyle={{
                fontFamily: 'Circular Std',
                margin: '4px',
                MozAppearance: 'none',
                fontSize: '26px',
                width: '34px',
                paddingLeft: '3px',
                paddingRight: '3px',
                textAlign: 'center',
                border: 'none',
                borderRadius: 0,
                borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
                '-moz-appearance': 'textfield',
              }}
              onChange={value => {
                profileStore.contactStore.setEmailVerificationCode(value);
                setCode(value);
                triggerSave(value);
              }}
              inputMode="number"
              value={code}
            />
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
});
export default VerifyEmailModal;
